export const dhryRoute = [
  {path: '/dhry', component: () => import('./views')},
  {path: '/dhry/shoushu', component: () => import('./views/shoushu')},
  {
    path: '/dhry/home',
    component: () => import('./views/home')
  },
  {path: '/dhry/all', component: () => import('./views/all')},
  {path: '/dhry/message', component: () => import('./views/message')},
  {path: '/dhry/team', component: () => import('./views/team')},
  {path: '/dhry/picc', component: () => import('./views/picc')},
  {path: '/dhry/dzd/pre', component: () => import('./views/dzd/pre')},
  {path: '/dhry/dzd', component: () => import('./views/dzd')},
  {
    path: '/dhry/news',
    meta: {
      keepAlive: true
    },
    component: () => import('./views/news')
  },
  {path: '/dhry/news/detail', component: () => import('./views/news/detail')},
  {path: '/dhry/news/search', component: () => import('./views/news/search')}
]



// WEBPACK FOOTER //
// ./src/page/dhry/dhryRoute.js